import { createSlice } from '@reduxjs/toolkit';
import { getUserInfo } from '../../utils/auth-token-utils/cookie';

// Hydrate user from localStorage (populated on login when "Remember me" is checked)
// so that role-based routing works immediately on refresh and we avoid a flash
// of wrong-role UI while getProfile() is in flight.
const hydrateUserDetails = () => {
  const stored = getUserInfo();
  if (stored && typeof stored === 'object' && Object.keys(stored).length > 0) {
    // `storeUserInfo` saves the full admin-login response, whose user is
    // `.profile` ({ token, profile, refreshToken }). Older builds stored
    // `.user` / `.userDetails`; a bare profile object is accepted as-is.
    const user = stored.profile || stored.user || stored.userDetails || stored;
    // Without a userType the role check would default to manager and bounce
    // an admin off admin-only routes on reload. Treat that as "not loaded"
    // so ProtectedRoute waits for the profile fetch instead.
    return user && typeof user === 'object' && user.userType ? user : null;
  }
  return null;
};

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    toaster: null,
    modal: null,
    userDetails: hydrateUserDetails(),
    adModal: false,
    activeMenu: 'home',
    loader:false,
  },
  reducers: {
    showToast: (state, param) => {
      const { payload } = param;
      state.toaster = payload;
    },
    showModal: (state, param) => {
      const { payload } = param;
      state.modal = payload;
    },
    showAdModal: (state, param) => {
      const { payload } = param;
      state.adModal = payload;
    },
    saveUserDetails: (state, param) => {
      const { payload } = param;
      // Preserve userType if it exists in the current state but not in the new payload
      const currentUserType = state.userDetails?.userType;
      const newUserType = payload?.userType;
      
      state.userDetails = {
        ...payload,
        // If we have a userType in current state but not in new payload, preserve it
        userType: newUserType || currentUserType,
      };
    },
    setActiveMenu: (state, param) => {
      const { payload } = param;
      state.activeMenu = payload;
    },
    setLoading: (state, param) => {
      const { payload } = param;
      state.loader = payload;
    },
  },
});

const { actions, reducer } = commonSlice;

export const { showToast, showModal, showAdModal, saveUserDetails, setActiveMenu,setLoading } = actions;
export default reducer;
